import { RuleProps } from 'types/application';


export const AA_CONTACT_DETAILS = [
  {
    sectionID: 'contact-particulars',
    sectionName: 'Contact Person Particulars',
    sameAsOption: 'Applicant Particulars',
    fieldList: [
      {
        id: 'same-as-applicant',
        label: 'Same as Applicant Particulars?',
        type: 'radio',
        options: [
          { optID: 'Yes', optLabel: 'Yes' },
          { optID: 'No', optLabel: 'No' }
        ],
        span: 12,
        rule: { required: true }
      },
      {
        id: 'contactName',
        label: 'Name',
        type: 'text',
        rule: {
          required: true,
          baseIds: ['contact-particulars-same-as-applicant'],
          hidden: ({ baseValues }: RuleProps) => baseValues?.['contact-particulars-same-as-applicant'] !== 'No'
        }
      },
      {
        id: 'designation',
        label: 'Designation',
        type: 'text',
        rule: { required: true }
      },
      {
        id: 'telNumber',
        label: 'Office No',
        type: 'number',
        rule: { charLength: 15 }
      },
      {
        id: 'mobileNo',
        label: 'Mobile No',
        type: 'number',
        rule: {
          required: true,
          baseIds: ['contact-particulars-same-as-applicant'],
          hidden: ({ baseValues }: RuleProps) => baseValues?.['contact-particulars-same-as-applicant'] !== 'No'
        }
      },
      {
        id: 'email',
        label: 'Email Address',
        type: 'text',
        rule: { 
          required: true, 
          charLength: 64, 
          baseIds: ['contact-particulars-same-as-applicant'], 
          hidden: ({ baseValues }: RuleProps) => baseValues?.['contact-particulars-same-as-applicant'] !== 'No' 
        }
      },
      { 
        id: 'faxNo', 
        label: 'Fax No.', 
        type: 'text',
        rule: {
          baseIds: ['contact-particulars-same-as-applicant'],
          hidden: ({ baseValues }: RuleProps) => baseValues?.['contact-particulars-same-as-applicant'] !== 'No'
        }
      }
    ]
  },
  {
    sectionID: 'contact-address',
    sectionName: 'Contact Person Address',
    sameAsOption: 'Company Registered Address',
    fieldList: [
      {
        id: 'same-as-company-address',
        label: 'Same as Company Registered Address?',
        type: 'radio',
        options: [
          { optID: 'Yes', optLabel: 'Yes' },
          { optID: 'No', optLabel: 'No' }
        ],
        span: 12,
        rule: { required: true }
      },
      {
        id: 'postal',
        label: 'Postal Code',
        type: 'postal',
        rule: {
          required: true,
          baseIds: ['contact-address-same-as-company-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['contact-address-same-as-company-address'] !== 'No'
        }
      },
      {
        id: 'blockHouse',
        label: 'Block/House No.',
        type: 'text',
        rule: { 
          required: true,
          baseIds: ['contact-address-same-as-company-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['contact-address-same-as-company-address'] !== 'No'
        }
      },
      {
        id: 'street',
        label: 'Street Name',
        type: 'text',
        rule: { 
          required: true, 
          charLength: 64,
          baseIds: ['contact-address-same-as-company-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['contact-address-same-as-company-address'] !== 'No'
        }
      },
      {
        id: 'floor',
        label: 'Floor No.',
        type: 'text',
        placeholder: 'Eg: 01, B1, 01M',
        rule: { 
          charLength: 3,
          baseIds: ['contact-address-same-as-company-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['contact-address-same-as-company-address'] !== 'No'
        },
        span: 2
      },
      {
        id: 'unit',
        label: 'Unit No.',
        type: 'text',
        placeholder: 'Eg: #05-01',
        rule: { 
          charLength: 5,
          baseIds: ['contact-address-same-as-company-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['contact-address-same-as-company-address'] !== 'No'
        },
        span: 2
      },
      {
        id: 'building',
        label: 'Building Name',
        type: 'text',
        rule: { 
          charLength: 66,
          baseIds: ['contact-address-same-as-company-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['contact-address-same-as-company-address'] !== 'No'
        }
      }
    ]
  },
  {
    sectionID: 'billing-particulars',
    sectionName: 'Billing Person Particulars',
    sameAsOption: 'Contact Person Particulars',
    fieldList: [
      {
        id: 'same-as-contact',
        label: 'Same as Contact Person Particulars?',
        type: 'radio',
        options: [
          { optID: 'Yes', optLabel: 'Yes' },
          { optID: 'No', optLabel: 'No' }
        ],
        span: 12,
        rule: { required: true }
      },
      {
        id: 'billingName',
        label: 'Name',
        type: 'text',
        rule: {
          required: true,
          baseIds: ['billing-particulars-same-as-contact'],
          hidden: ({ baseValues }: RuleProps) => baseValues?.['billing-particulars-same-as-contact'] !== 'No'
        }
      },
      {
        id: 'designation',
        label: 'Designation',
        type: 'text',
        rule: { 
          required: true,
          baseIds: ['billing-particulars-same-as-contact'],
          hidden: ({ baseValues }: RuleProps) => baseValues?.['billing-particulars-same-as-contact'] !== 'No'
        }
      },
      {
        id: 'telNumber',
        label: 'Office No',
        type: 'number',
        rule: { 
          charLength: 15,
          baseIds: ['billing-particulars-same-as-contact'],
          hidden: ({ baseValues }: RuleProps) => baseValues?.['billing-particulars-same-as-contact'] !== 'No'
        }
      },
      {
        id: 'mobileNo',
        label: 'Mobile No',
        type: 'number',
        rule: { 
          required: true,
          baseIds: ['billing-particulars-same-as-contact'], 
          hidden: ({ baseValues }: RuleProps) => baseValues?.['billing-particulars-same-as-contact'] !== 'No' 
        }
      },
      {
        id: 'email',
        label: 'Email Address',
        type: 'text',
        rule: { 
          required: true, 
          charLength: 64, 
          baseIds: ['billing-particulars-same-as-contact'], 
          hidden: ({ baseValues }: RuleProps) => baseValues?.['billing-particulars-same-as-contact'] !== 'No' 
        }
      },
      { 
        id: 'faxNo', 
        label: 'Fax No.', 
        type: 'text',
        rule: {
          baseIds: ['billing-particulars-same-as-contact'],
          hidden: ({ baseValues }: RuleProps) => baseValues?.['billing-particulars-same-as-contact'] !== 'No'
        }
      }
    ]
  },
  {
    sectionID: 'billing-address',
    sectionName: 'Billing Person Address',
    sameAsOption: 'Contact Person Address',
    fieldList: [
      {
        id: 'same-as-contact-address',
        label: 'Same as Contact Person Address?',
        type: 'radio',
        options: [
          { optID: 'Yes', optLabel: 'Yes' },
          { optID: 'No', optLabel: 'No' }
        ],
        span: 12,
        rule: { required: true }
      },
      {
        id: 'postal',
        label: 'Postal Code',
        type: 'postal',
        rule: {
          required: true,
          baseIds: ['billing-address-same-as-contact-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['billing-address-same-as-contact-address'] !== 'No'
        }
      },
      {
        id: 'blockHouse',
        label: 'Block/House No.',
        type: 'text',
        rule: { 
          required: true,
          baseIds: ['billing-address-same-as-contact-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['billing-address-same-as-contact-address'] !== 'No'
        }
      },
      {
        id: 'street',
        label: 'Street Name',
        type: 'text',
        rule: { 
          required: true, 
          charLength: 64,
          baseIds: ['billing-address-same-as-contact-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['billing-address-same-as-contact-address'] !== 'No'
        }
      },
      {
        id: 'floor',
        label: 'Floor No.',
        type: 'text',
        placeholder: 'Eg: 01, B1, 01M',
        rule: { 
          charLength: 3,
          baseIds: ['billing-address-same-as-contact-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['billing-address-same-as-contact-address'] !== 'No'
        },
        span: 2
      },
      {
        id: 'unit',
        label: 'Unit No.',
        type: 'text',
        placeholder: 'Eg: #05-01',
        rule: { 
          charLength: 5,
          baseIds: ['billing-address-same-as-contact-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['billing-address-same-as-contact-address'] !== 'No'
        },
        span: 2
      },
      {
        id: 'building',
        label: 'Building Name',
        type: 'text',
        rule: { 
          charLength: 66,
          baseIds: ['billing-address-same-as-contact-address'],
          hidden: ({ baseValues }: RuleProps) =>
            baseValues?.['billing-address-same-as-contact-address'] !== 'No'
        }
      }
    ]
  },
  {
    sectionID: 'giro-details',
    sectionName: 'GIRO Details',
    fieldList: [
      {
        id: 'doYouWantYourRenewalBePaidThroughGiro',
        label: 'Do you want your renewal be paid through GIRO?',
        type: 'radio',
        options: [
          { optID: 'Yes', optLabel: 'Yes' },
          { optID: 'No', optLabel: 'No' }
        ],
        span: 12,
        rule: { required: false }  // Optional field - defaults to No if not selected
      },
      {
        id: 'doYouHaveAnExistingGiroArrangementWithImda',
        label: 'Do you have an existing GIRO arrangement with IMDA?',
        type: 'radio',
        options: [
          { optID: 'Yes', optLabel: 'Yes' },
          { optID: 'No', optLabel: 'No' }
        ],
        span: 12,
        rule: {
          baseIds: ['giro-details-doYouWantYourRenewalBePaidThroughGiro'],
          required: ({ baseValues }: RuleProps) => 
            baseValues?.['giro-details-doYouWantYourRenewalBePaidThroughGiro'] === 'Yes',
          hidden: ({ baseValues }: RuleProps) => 
            baseValues?.['giro-details-doYouWantYourRenewalBePaidThroughGiro'] !== 'Yes'
        }
      },
      {
        id: 'bank',
        label: 'Bank',
        type: 'text',
        rule: {
          baseIds: ['giro-details-doYouHaveAnExistingGiroArrangementWithImda'],
          required: ({ baseValues }: RuleProps) => 
            baseValues?.['giro-details-doYouHaveAnExistingGiroArrangementWithImda'] === 'Yes',
          hidden: ({ baseValues }: RuleProps) => 
            baseValues?.['giro-details-doYouHaveAnExistingGiroArrangementWithImda'] !== 'Yes'
        }
      },
      {
        id: 'bankAccountNumber',
        label: 'Bank account number',
        type: 'text',
        rule: {
          baseIds: ['giro-details-doYouHaveAnExistingGiroArrangementWithImda'],
          required: ({ baseValues }: RuleProps) => 
            baseValues?.['giro-details-doYouHaveAnExistingGiroArrangementWithImda'] === 'Yes',
          hidden: ({ baseValues }: RuleProps) => 
            baseValues?.['giro-details-doYouHaveAnExistingGiroArrangementWithImda'] !== 'Yes'
        }
      }
    ]
  }
];
